const PinterestIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0109 14.935C11.4973 14.9513 11.9365 15.6212 13.2229 15.6212C15.6389 15.6375 17.3018 13.7096 17.8195 11.177C19.6236 2.4031 7.33998 1.70053 6.08495 8.92228C5.78688 10.6215 6.2732 12.5822 7.54392 13.2194C8.51657 13.7096 8.57932 12.3044 8.28125 11.6999C6.96347 9.02031 8.54795 6.60217 10.6187 5.91594C12.564 5.26239 13.9446 5.80157 14.9957 6.92895C16.3448 8.3831 15.733 12.3371 14.1328 13.5952C13.5681 14.0363 12.5327 14.1344 11.9993 13.6115C10.9011 12.5495 12.5954 10.2947 12.3444 8.64452C12.0934 7.01064 9.61472 7.25572 9.48922 9.65753C9.42647 10.8829 9.7716 11.2424 9.50491 12.4678C9.08134 14.4285 7.79493 18.4315 8.70483 20C10.0383 19.3464 10.6972 15.4251 11.0109 14.935Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

export default PinterestIcon;
